import { alpha, type Theme } from '@mui/material/styles';
import type { DataGridProProps, GridRowClassNameParams } from '@mui/x-data-grid-pro';

export const HI_GRID_ROW_EVEN_CLASS = 'hi-grid-row-even';

type DataGridPalette = {
  bg?: string;
  headerBg?: string;
  pinnedBg?: string;
};

function getDataGridBg(theme: Theme): string {
  const dataGridPalette = (theme.palette as Theme['palette'] & { DataGrid?: DataGridPalette })
    .DataGrid;
  return dataGridPalette?.bg ?? theme.palette.background.default;
}

/** Striped rows — palette.DataGrid has no stripe token (only bg/headerBg/pinnedBg). */
export function defaultStripedRowClassName(params: GridRowClassNameParams): string {
  return params.indexRelativeToCurrentPage % 2 === 0 ? HI_GRID_ROW_EVEN_CLASS : '';
}

/** Merge host theme tokens + consumer sx. MUI already applies components.MuiDataGrid globally;
 *  this adds palette-derived row stripe + consumer overrides in one sx pipeline. */
export function mergeGridSx(
  theme: Theme,
  consumerSx?: DataGridProProps['sx'],
): DataGridProProps['sx'] {
  const gridBg = getDataGridBg(theme);
  const stripeBg = alpha(gridBg, 0.06);

  const themeSx: DataGridProProps['sx'] = {
    '& .MuiDataGrid-row': { backgroundColor: gridBg },
    [`& .${HI_GRID_ROW_EVEN_CLASS}`]: { backgroundColor: stripeBg },
  };

  if (!consumerSx) return themeSx;
  return Array.isArray(consumerSx) ? [themeSx, ...consumerSx] : [themeSx, consumerSx];
}
